import { CSSObject } from '@chakra-ui/react';
import { BreadcrumbSchema } from './Breadcrumb.styles';

export const breadcrumbStyles: BreadcrumbSchema = {
  breadcrumbWrapper: {
    borderRadius: 'base',
    bgGradient: 'linear(to-b, beta.600, beta.700)',
    p: '2',
    mb: '4',
    sx: {
      '.chakra-breadcrumb__list': {
        display: 'flex',
      },
      '::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  breadcrumbItemBreadcrumb: {
    gap: '1.5',
  },
  breadcrumbLinkItem: {
    textDecoration: 'underline',
    color: 'white',
    _hover: {
      textDecoration: 'none',
    },
    sx: {
      '&:not([href])': {
        textDecoration: 'none',
        color: '#80FF00',
      },
    },
  },
};

export const ChevronRightIcon: CSSObject = {
  display: 'block',
  m: '0',
  color: 'blackAlpha.500',
};
